import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const hrCalendarService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/HRCalendar`, { headers });
  },

  getActive: async () => {
    return await axios.get(`${domain}/api/HRCalendar/active`, { headers });
  },

  getCurrentYear: async () => {
    return await axios.get(`${domain}/api/HRCalendar/current-year`, { headers });
  },

  getById: async (id) => {
    return await axios.get(`${domain}/api/HRCalendar/${id}`, { headers });
  },

  create: async (payload) => {
    return await axios.post(`${domain}/api/HRCalendar`, payload, { headers });
  },

  update: async (id, payload) => {
    return await axios.put(`${domain}/api/HRCalendar/${id}`, payload, { headers });
  },

  delete: async (id) => {
    return await axios.delete(`${domain}/api/HRCalendar/${id}`, { headers });
  },
};

export default hrCalendarService;